<template>
  <div class="video">
    <iframe class="video__frame" width="100%" height="auto" :src="this.$props.url" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</template>


<script>
export default {
  name: 'videoEmbed',
  props: {
    url: {
      type: String,
    },
  },
};
</script>


<style lang="scss" scoped>
  .video {
    position: relative;
    height: 0;
    overflow: hidden;
    padding-bottom: 56.2%;
  }
  .video__frame {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
